module.exports = __webpack_public_path__ + "static/gm-25-cd62620f522e472ce275af2de1087c18.jpg";